import React from 'react';
import ReactDOM from 'react-dom';
import { InteractionStatus, InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider, useMsal } from '@azure/msal-react';

import { App } from './App';
import * as serviceWorker from './serviceWorker';
import configsLoader, { msalConfig } from '@config/config';
import { AppInsights } from '@modules/core/utils';
import { initializeMsal, msal } from '@config/msalConfig';

declare global {
    namespace NodeJS {
        interface ProcessEnv {
            REACT_APP_MOCK_SERVER_API_URL: string;
            PORT: string;
            DEV: boolean;
            SASS_PATH: string;
            DISABLE_APP_INSIGHTS: boolean;
        }
    }
}

configsLoader.then(async () => {
    if (process.env.REACT_APP_DEV) {
        ReactDOM.render(
            // ToDo errors when using Eniram common ui lib in strict mode
            <App />,
            document.getElementById('root')
        );
        return;
    }

    AppInsights.init(msalConfig.REACT_APP_INSIGHTS_CODE);
    await initializeMsal(msalConfig);

    ReactDOM.render(
        <MsalProvider instance={msal.instance}>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={{
                    scopes: msal.scopes
                }}
            >
                <AppContainer />
            </MsalAuthenticationTemplate>
        </MsalProvider>,
        document.getElementById('root')
    );
});

export const AppContainer = () => {
    const { inProgress } = useMsal();

    if (inProgress !== InteractionStatus.None) {
        AppInsights.trackException(null, { type: 'Index.tsx:InterationInProgress:SkipContent' });
        return null; // Prevent rendering while MSAL is processing an interaction
    }

    return <App />;
};

serviceWorker.unregister();
